<script>
    import R, {LOADER} from "../lib/requests";
    import {formatDate, millisecondsToHours, toEuro, toInt} from "../lib/lib";
    import {PAYMENT_TYPES} from "../lib/constants";
    import Notifier from "../stores/notifier";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import Alert from "../stores/alerts";

    export let search;

    let report = null;
    let driver = null;
    let vehicle = null;
    let dateFrom = '';
    let dateTo = '';

    const load = () => {
        const onSuccess = result => {
            dateFrom = result.date_from;
            dateTo = result.date_to;
            driver = result.driver;
            vehicle = result.vehicle;
            report = result.report;
        }

        const onFailure = err => {
            Alert.warning("Report", "En error occurred while loading report");
        };

        R.handle(R.shift.report, search, onSuccess, onFailure, LOADER.POPUP);
    }

    const copyTable = async (event) => {
        const table = document.getElementById("shifts-table");
        const tableHtml = table.outerHTML; // αντιγράφει όλο το HTML του πίνακα

        try {
            await navigator.clipboard.writeText(tableHtml);
            Notifier.showMessage("Table copied to clipboard");
        } catch (e) {
            Notifier.showError("Could not copy table to clipboard!");
        }
    }

    load();
</script>

{#if report}

    <table class="table table-excel mb-2" id="shifts-table">
        <thead>
        <tr>
            <th>Date Range</th>
            <td colspan="13">
                {formatDate(dateFrom, 'd/m/y')} - {formatDate(dateTo, 'd/m/y')}
            </td>
        </tr>
        {#if driver}
            <tr>
                <th>Driver</th>
                <td colspan="13">
                    {driver.name}
                </td>
            </tr>
        {/if}
        {#if vehicle}
            <tr>
                <th>Vehicle</th>
                <td colspan="13">
                    {vehicle.licence_no}
                </td>
            </tr>
        {/if}
        <tr>
            <th colspan="5">&nbsp;</th>
            <th colspan="2" class="text-center border-lr">Incomes - On Account</th>
            <th colspan="2" class="text-center border-lr">Incomes - Cash</th>
            <th colspan="2" class="text-center border-lr">Incomes - Credit Card</th>
            <th colspan="2" class="text-center border-lr">Expenses</th>
            <th class="text-center border-lr"></th>
        </tr>
        <tr>
            <th>Date</th>
            <th class="text-center">Start Time</th>
            <th class="text-center">End Time</th>
            <th class="text-center">Shift</th>
            <th class="text-center">Km Total</th>
            <!-- Incomes On Account -->
            <th class="border-l text-center">Gross</th>
            <th class="border-r text-center">Net</th>
            <!-- Incomes Cash -->
            <th class="border-l text-center">Gross</th>
            <th class="border-r text-center">Net</th>
            <!-- Incomes Credit Card -->
            <th class="border-l text-center">Gross</th>
            <th class="border-r text-center">Net</th>
            <!-- expenses -->
            <th class="border-l text-center">On Account</th>
            <th class="border-r text-center">Cash</th>
            <!-- Ταμείο -->
            <th class="border-lr text-center">ΤΑΜΕΙΟ</th>
        </tr>
        </thead>

        <tbody>
        {#each report.list as item}
            <tr>
                <td>{formatDate(item.start_at, 'd/m/y')}</td>
                <td class="text-center">{formatDate(item.start_at, 'H:i')}</td>
                <td class="text-center">{formatDate(item.end_at, 'H:i')}</td>
                <td class="text-center">{millisecondsToHours(item.duration)}</td>
                <td class="text-center">{toInt(item.total_klm)}</td>
                <!-- Incomes On Account -->
                <td class="border-l text-center">{toEuro(item.incomes_on_account)}</td>
                <td class="border-r text-center">{toEuro(item.incomes_on_account_net)}</td>
                <!-- Incomes Cash -->
                <td class="border-l text-center">{toEuro(item.incomes_cash)}</td>
                <td class="border-r text-center">{toEuro(item.incomes_cash_net)}</td>
                <!-- Incomes Credit Card -->
                <td class="border-l text-center">{toEuro(item.incomes_credit_card)}</td>
                <td class="border-r text-center">{toEuro(item.incomes_credit_card_net)}</td>
                <!-- expenses -->
                <td class="border-l text-center">{toEuro(item.expenses.on_account.total)}</td>
                <td class="border-r text-center">{toEuro(item.expenses.cash.total)}</td>
                <!-- Ταμείο -->
                <td class="border-lr text-center">{toEuro(item.fund)}</td>
            </tr>
        {/each}
        <tr>
            <td colspan="3"><b>Total</b></td>
            <td class="text-center"><b>{millisecondsToHours(report.totals.duration)}</b></td>
            <td class="text-center"><b>{toInt(report.totals.klm)}</b></td>
            <!-- Incomes On Account -->
            <td class="border-l text-center"><b>{toEuro(report.totals.incomes.on_account)}</b></td>
            <td class="border-r text-center"><b>{toEuro(report.totals.incomes.on_account_net)}</b></td>
            <!-- Incomes Cash -->
            <td class="border-l text-center"><b>{toEuro(report.totals.incomes.cash)}</b></td>
            <td class="border-r text-center"><b>{toEuro(report.totals.incomes.cash_net)}</b></td>
            <!-- Incomes Credit Card -->
            <td class="border-l text-center"><b>{toEuro(report.totals.incomes.credit_card)}</b></td>
            <td class="border-r text-center"><b>{toEuro(report.totals.incomes.credit_card_net)}</b></td>
            <!-- expenses -->
            <td class="border-l text-center"><b>{toEuro(report.totals.expenses.on_account)}</b></td>
            <td class="border-r text-center"><b>{toEuro(report.totals.expenses.cash)}</b></td>
            <!-- Ταμείο -->
            <td class="border-lr text-center"><b>{toEuro(report.totals.fund)}</b></td>
        </tr>
        </tbody>
    </table>
    <div class="mb-4">
        <button class="btn btn-danger d-flex align-items-center" on:click={copyTable}>
            <AppIcon icon="copy"/>&nbsp;Copy Report
        </button>
    </div>

    <div class="row">
        <div class="col-md-4 col-12">
            <table class="table table-excel mb-4">
                <thead>
                <tr>
                    <th>Locals</th>
                    <th class="text-center">Number</th>
                    <th class="text-center">Price</th>
                </tr>
                <tbody>
                {#each Object.keys(report.locals) as key}
                    {#if report.locals[key]}
                        <tr>
                            <th>{PAYMENT_TYPES[key]}</th>
                            <td class="text-center">{report.locals[key].number}</td>
                            <td class="text-center">{toEuro(report.locals[key].price)}</td>
                        </tr>
                    {/if}
                {/each}
                </tbody>
            </table>
        </div>
    </div>
{/if}

